import Marquee from "react-fast-marquee";
import { Smartphone } from "lucide-react";

export default function ScreenshotsMarquee({ screenshots, resolveUrl, title = "App Screenshots", subtitle = "Latest in-app gallery" }) {
  if (!screenshots || screenshots.length === 0) {
    return null; // Hide entirely if no screenshots uploaded
  }
  const items = screenshots.length < 5 ? [...screenshots, ...screenshots, ...screenshots] : screenshots;
  return (
    <section className="bg-dark px-0 sm:px-6 lg:px-8 py-8" data-testid="screenshots-marquee">
      <div className="max-w-7xl mx-auto">
        <div className="px-4 sm:px-0 text-center mb-4">
          <div className="label-gold">{subtitle}</div>
          <h3 className="font-display text-2xl sm:text-3xl font-bold text-[#ffd700] mt-1">{title}</h3>
        </div>
        <div className="relative marquee-overlay on-dark overflow-hidden">
          <Marquee speed={45} gradient={false} pauseOnHover direction="left">
            {items.map((s, i) => (
              <div
                key={`${s.id}-${i}`}
                className="shrink-0 w-[180px] sm:w-[210px] aspect-[9/16] cream-card overflow-hidden mx-2 sm:mx-3"
              >
                <img src={resolveUrl(s.url)} alt={`screenshot-${i}`} className="w-full h-full object-cover" />
              </div>
            ))}
          </Marquee>
        </div>
      </div>
    </section>
  );
}
